










import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import EventList from './components/EventList.vue';
import { eventsModuleName } from './store/index';
import { Actions } from './store/actions';
import { Getters } from './store/getters';
const eventsModule = namespace(eventsModuleName);

@Component({
  components: {
    EventList,
  },
})
export default class Events extends Vue {

  private isBusy: boolean = true;

  @eventsModule.Getter(Getters.EVENTS) private events!: string;
  @eventsModule.Action(Actions.FETCH_EVENTS) private fetchEvents: any;

  public async mounted() {
    await this.fetchEvents();
    this.isBusy = false;
  }
}
